import { z } from 'zod';
import { shiftRowSchema } from './shiftCommonSchema';
const getShiftParamsSchema = z.object({
    shiftId: z.string().uuid(),
});
const getShiftResponseSchema = shiftRowSchema.merge(z.object({
    permissions: z.string().array().optional(), // TODO: Change to required - CRMS-3034
}));
const partialGetShiftResponseSchema = getShiftResponseSchema.omit({
    columns: true,
});
export const getShiftFunctionDef = {
    name: 'getShift',
    requestSchema: getShiftParamsSchema,
    responseSchema: getShiftResponseSchema,
};
